import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
	getPage(param,switched) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/page?switched='+switched,
			method: 'post',
			data: param
		})
	},
	getStatus(param,switched) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/status?switched='+switched,
			method: 'post',
			data: param
		})
	},
	getStatus2(param,type) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/status2?type='+type,
			method: 'post',
			data: param
		})
	},
	getResultsById(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/selectById',
			method: 'post',
			params: param
		})
	},
	getCount(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/selectCount',
			method: 'post',
			data: param
		})
	},
	getCount2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/selectCount2',
			method: 'post',
			data: param
		})
	},
	selectByIdPart(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/selectByIdPart',
			method: 'post',
			params: param
		})
	},
	selectByIdRisk(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/selectByIdRisk',
			method: 'post',
			params: param
		})
	},
	getExcel(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/excel',
			method: 'get',
			params: param
		})
	},
	getMaintainStatus() {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainPlan/countMaintainStatus',
			method: 'post',
		})
	},
	getMaintainPage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainPlan/page?type='+param.type,
			method: 'post',
			data: param,
		})
	},
	getMaintainInfoPage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainInfo/page2',
			method: 'post',
			data: param,
		})
	},
	getMaintainTypeInfoPage(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentTypeMaintainInfo/page2',
			method: 'post',
			data: param,
		})
	},
	getMaintainGroup(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainGroup/page?type='+param.type+"&id="+param.id,
			method: 'post',
			data: param,
		})
	},
	deleteMaintainGroup(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainGroup/delete',
			method: 'delete',
			params: param,
		})
	},
	addMaintainGroup(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainGroup/insert',
			method: 'post',
			data: param,
		})
	},
	saveMaintainRest(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentaintainRest/update',
			method: 'post',
			data: param,
		})
	},
	startORstop(param){
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainPlan/startORstop',
			method: 'post',
			data: param,
		})
	},
	exportList(param,switched){
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/listExcel?switched='+switched,
			method: 'post',
			data: param,
		})
	},
	checkSaveRemark(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/saveRemark',
	    method: 'post',
	    params:param
	  })
	},
	check(data,checkUser) {//checkUser 1 班长；2 系长; 3 课长
	  return request({
	    url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/check/'+checkUser,
	    method: 'post',
	    data:data
	  })
	},
	checkBack(data,checkUser) {//checkUser 1 班长；2 系长; 3 课长
	  return request({
	    url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/checkBack/'+checkUser,
	    method: 'post',
	    data:data
	  })
	},
	acquiescence(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/equipmentMaintainGroup/acquiescence',
	    method: 'post',
	    params:param
	  })
	},
	saveFileId(param1,param2) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/equipmentMaintainRecord/saveFileId?id='+param1+'&fileId='+param2,
	    method: 'post',
	  })
	},
	resetPlanStatus(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMaintainPlan/resetPlanStatus',
      method: 'post',
      data: params
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/maintenance/maintenance.js